import { render, staticRenderFns } from "./chainLifeCycle.vue?vue&type=template&id=b0d7dd08&scoped=true&"
import script from "./chainLifeCycle.vue?vue&type=script&lang=js&"
export * from "./chainLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./chainLifeCycle.vue?vue&type=style&index=0&id=b0d7dd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d7dd08",
  null
  
)

export default component.exports